import EmailTemplatesComponent from '../Components/Email/EmailTemplatesComponent';

function EmailTemplatesPage() {
  return <EmailTemplatesComponent />;
}

export default EmailTemplatesPage;
